'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useIsMobile } from '@hooks/use-is-mobile';
import { useIsClient } from '@lib/rich-text-section/hooks/use-is-client';
import { AnimatePresence, motion } from 'motion/react';
import { AmbientBackground } from '@/app/onboarding/_components/workspace-setup/clai-orb';
import { authPanelDeckFor } from './auth-panel-deck-for';
import { FeatureDeck } from './feature-deck';

/**
 * Right half of the auth screens: the product tour on
 * sign-up, a welcome-back tour on sign-in. Same card,
 * background and type scale as onboarding's setup preview
 * panel.
 */
export function AuthFeaturePanel() {
  const $ = _c(14);
  const t0 = usePathname();
  let t1;
  if ($[0] !== t0) {
    t1 = authPanelDeckFor(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const deck = t1;
  const isClient = useIsClient();
  const isMobile = useIsMobile();
  const isLive = isClient && !isMobile;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-0 rounded-[21px]"><Image src="/assets/images/auth/carousel-section-bg.png" alt="" fill={true} sizes="(min-width: 768px) 50vw, 0px" className="animate-section-bg-float object-cover motion-reduce:animate-none" data-sentry-element="Image" data-sentry-source-file="auth-feature-panel.tsx" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isLive) {
    t3 = isLive ? <AmbientBackground className="opacity-60" /> : null;
    $[3] = isLive;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="border-primary/20 absolute inset-0 z-10 rounded-[21px] border" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== deck || $[7] !== isLive) {
    t5 = isLive ? <motion.div key={deck.id} className="flex min-h-0 flex-1 flex-col" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }}><FeatureDeck deck={deck} /></motion.div> : null;
    $[6] = deck;
    $[7] = isLive;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <div className="relative z-20 flex min-h-0 flex-1 flex-col"><AnimatePresence mode="wait" data-sentry-element="AnimatePresence" data-sentry-source-file="auth-feature-panel.tsx">{t5}</AnimatePresence></div>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <div className="bg-primary/5 relative flex h-full w-full flex-col overflow-clip rounded-[21px]" data-sentry-component="AuthFeaturePanel" data-sentry-source-file="auth-feature-panel.tsx">{t2}{t3}{t4}{t6}</div>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}